const React     = require("react");
const Form      = require("app/components/forms/Form");
const Price     = require("app/components/fields/Price");
const PropTypes = require("prop-types");
const checkout  = require("app/pipelines/checkout/giftcards");
const Textarea  = require("app/components/fields/Textarea");
const ZipField  = require("app/components/fields/ZipCity");
const CvrField  = require("app/components/fields/CVR");
const Trans = require('app/components/trans/Trans')

class BuyGiftcard extends Form {

    static get propTypes() {
        return {
            senderName:    PropTypes.string,
            senderEmail:   PropTypes.string,
            senderCompany: PropTypes.string,
            senderPhone:   PropTypes.string,
            senderAddress: PropTypes.string,
            senderCity:    PropTypes.string,
            senderZip:     PropTypes.string,
            senderCvr:     PropTypes.string,
        };
    }

    static get defaultProps() {
        return {
            senderName:    "",
            senderEmail:   "",
            senderCompany: "",
            senderPhone:   "",
            senderAddress: "",
            senderCity:    "",
            senderZip:     "",
            senderCvr:     "",
        };
    }

    get baseClassName() {
        return super.baseClassName + " giftcard-form";
    }

    performSubmit(form) {
        // Set as loading
        this.setState({loading: true});

        return checkout.add.request
           .dispatch(this.buildPayload(form))
           .then(cart => {
               this.onComplete(cart);
               return cart;
           })
           .catch(error => {
               this.onError(error.response.data);
           });
    }

    renderField(label, name, defVal, required = true, type = 'text') {
        const className = required ? 'field required' : 'field';
        const id = 'input_' + name;

        return (
            <div className={className}>
                <label htmlFor={id}>{label}</label>
                <input defaultValue={defVal} type={type}
                       id={id} name={name} required={required}/>
                {this.renderError(name)}
            </div>
        );
    }

    renderForm() {
        const {senderName, senderEmail, senderCompany, senderPhone, senderAddress, senderCity, senderZip, senderCvr} = this.props;

        return (
            <form onSubmit={this.onSubmit}>
                <h2>Dine oplysninger</h2>
                <p>Udfyld og Bekræft at dine oplysninger er korrekte.</p>
                <div className="inputs">

                    {this.renderField(translate('Navn'), 'sender_name', senderName)}
                    {this.renderField(translate('Telefon Nr'), 'sender_phone', senderPhone)}
                    {this.renderField(translate('Email'), 'sender_email', senderEmail, true, 'email')}
                    {this.renderField(translate('Firmanavn/Organisation'), 'sender_company', senderCompany, false)}
                    {this.renderField(translate('Adresse'), 'sender_address', senderAddress)}

                    <div className="field required">
                        <label htmlFor="inputZip">Postnr</label>
                        <ZipField id="inputZip" name="sender_zip"
                                  zip={senderZip} city={senderCity}
                                  zipPlaceholder="" cityPlaceholer=""
                                  required={true}/>
                        {this.renderError("sender_zip")}
                    </div>

                    <div className="field">
                        <label htmlFor="inputCvr">CVR Nr</label>
                        <CvrField defaultValue={senderCvr} type="text"
                                  id="inputCvr" autoComplete="cvr" name="sender_cvr" />
                        {this.renderError("sender_cvr")}
                    </div>

                    <div className="field required">
                        <label htmlFor="inputAmount">translate(Beløb i DKK)</label>
                        <Price id="inputAmount" name="amount"
                               required={true} defaultValue={25.0}/>
                        {this.renderError("amount")}
                    </div>

                    <div className="field required">
                        <label htmlFor="inputMessage"><Trans>Besked til modtager</Trans></label>
                        <Textarea id="inputMessage" name="message"
                                  required={true} limitLines={9}/>
                        {this.renderError("message")}
                    </div>

                </div>

                <div className="button leftalign">
                    <div className="submit-container">
                      <input type="submit" value={translate('Bestil')}/>
                    </div>
                </div>
            </form>
        );
    }
}

module.exports = BuyGiftcard;
